import { render, staticRenderFns } from "./PayerClaims.vue?vue&type=template&id=eb1002c6&scoped=true&"
import script from "./PayerClaims.vue?vue&type=script&lang=js&"
export * from "./PayerClaims.vue?vue&type=script&lang=js&"
import style0 from "./PayerClaims.vue?vue&type=style&index=0&id=eb1002c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1002c6",
  null
  
)

export default component.exports